import { Component, Input } from '@angular/core';
import { ContextMenuAwardService } from '../services/context-menu-awards-dialog.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';

@Component({
    selector: 'cv-context-menu-awards-dialog',
    templateUrl: './context-menu-awards-dialog.component.html',
    styleUrl: './context-menu-awards-dialog.component.scss'
})

export class ContextMenuAwardsDialogComponent {
    @Input() selectedRow: any;
    @Input() moduleKey: string;
    @Input() groupID: number;
    @Input() modalOpen: boolean;
    @Input() dashKey: string;
    @Input() isCxOne: boolean = true;
    @Input() isFromDashboard: boolean = true;

    data = { groupImageUrl: null, cmaf: null, folderedAwards: [] };
    isLoadingAwards: boolean = true;
    searchTerm: string = '';
    status: { hidden: boolean[], open: string[] } = { hidden: [], open: [] };
    activePanelIds: string[] = [];

    constructor (
        private cmaf: ContextMenuAwardService,
        private activeModal: NgbActiveModal,
        private dialogService: CvDialogService
    ) {
    }
    ngOnInit(): void {
        this.isLoadingAwards = true;
        this.cmaf.loadAvailableAwards(this.selectedRow).then((result) => {
            const sortedArray = result.data.folderedAwards.sort((a, b) => a.Key.localeCompare(b.Key));
            result.data.folderedAwards = Object.assign(result.data.folderedAwards, sortedArray);
            
            this.data = result.data;
            this.activePanelIds = this.data.folderedAwards.map((_, index) => 'panel' + index);
            this.isLoadingAwards = false;
        }
        );
    }
    
    close() {
        this.activeModal.close();
    };

    confirmGiveAward(award) {
        let title = this.cmaf.getLocalizedMessage("Manual_Awards_Context_Menu", "Confirm Give Award");
        let msg = this.cmaf.getLocalizedMessage("Manual_Awards_Context_Menu", "Are you sure you want to give out this award?");
        this.dialogService.showConfirmDialog(
            title,
            msg,
            true,
            () => {
                award.isGiving = true;
                this.cmaf.giveAward(award, this.selectedRow).then(
                     (response)=> {
                        if (response.status_code === 200) {
                            award.updateSuccess = true;
                            award.awardsCount++;
                        } else {
                            award.updateSuccess = false;
                        }
                    }
                ).finally(()=> {
                    award.isGiving = false;
                });
            },
            () => {}
        );
    };

    changeSearchTerm(term) {
        this.searchTerm = term;
    };

    showNoElementsMsg(): boolean {
        return !this.isLoadingAwards && this.data.folderedAwards.length === 0;
    }

    filterBySearchTerm(item) {
        let search = this.searchTerm.toLowerCase();
        if (search == "") return true;
        const ruleName = item.rule?.RuleName || '';
        return ruleName.toLowerCase().includes(search);
    };
    
    onPanelChange(openPanels: any) {
        const panelIds = openPanels as string | string[];
        this.status.open = Array.isArray(panelIds) ? panelIds : [panelIds];
    }
}
